// extracted by mini-css-extract-plugin
export default {"question_grp":"Quiz_question_grp__WNyyK","question":"Quiz_question__SeZ4+","radio_container":"Quiz_radio_container__aud7v","output":"Quiz_output__dEn4P"};